import jssVariables from "../../jss_setup";

export const SearchFeedback = {
  logoContr: {
    background: jssVariables.colors.base_color,
    borderRadius: jssVariables.half_gap,
  },
};
